import {
  Box,
  Button,
  Flex,
  Text,
  Input,
  Select,
  InputLeftElement,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  InputGroup,
} from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useState } from "react";

const Announcements = () => {
  const [radioValue, setRadioValue] = useState("all");

  // Dummy data for table rows
  const requestData = [
    {
      type: "Module outage",
      application: "Smart Order - Context",
      start: "12/11/24 at 20:00PM",
      end: "12/11/24 at 20:00PM",
      createdBy: "Me",
      status: "Live",
    },
    {
      type: "Module outage",
      application: "Smart Order - Context",
      start: "12/11/24 at 20:00PM",
      end: "12/11/24 at 20:00PM",
      createdBy: "Me",
      status: "Pending",
    },
    {
      type: "Module outage",
      application: "Smart Order - Context",
      start: "12/11/24 at 20:00PM",
      end: "12/11/24 at 20:00PM",
      createdBy: "Lana Steiner  ",
      status: "Completed",
    },
  ];

  return (
    <Box flex="1" pt="40px" px="8">
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="30px" color="#101828">
          Announcements
        </Text>
        <Button
          background="#1e98d7"
          color="#ffffff"
          _hover="none"
          fontSize="14px"
        >
          Create an announcement
        </Button>
      </Flex>

      {/* Filters Section */}
      <Flex gap={4} wrap="wrap" mb={6}>
      <InputGroup flex="1" maxW={{ base: "180px", md: "270px" }}>
          <InputLeftElement pointerEvents="none">
            <LuSearch color="#999999" />
          </InputLeftElement>
          <Input placeholder="Search" fontSize="12px" />
        </InputGroup>
        <Select
          placeholder="Application (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
        <Select
          placeholder="Status (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
      </Flex>

      {/* Responsive Table */}
      <Box overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Type
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Application
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Start
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                End
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Created by
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Status
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              ></Th>
            </Tr>
          </Thead>

          <Tbody>
            {requestData.map((request, index) => (
              <Tr key={index}>
                <Td pl={0} py={7} color="#475467" fontSize="12px">
                  {request.type}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.application}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.start}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.end}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.createdBy}
                </Td>
                <Td pl={0}>
                  <Box
                          px="10px"
                          py="5px"
                          borderRadius="54px"
                          border="1px solid #4b5565"
                          backgroundColor="transparent"
                          fontSize="12px"
                          fontFamily="Inter, sans-serif"
                          color="#4b5565"
                          textAlign="center"
                          display="inline-block"
                          minWidth="50px" 
                          maxWidth="200px" 
                          width="auto" 
                          height="28px"
                          lineHeight="18px"
                          whiteSpace="nowrap" 
                  >
                    {request.status}
                  </Box>
                </Td>
                <Td
                  pl={0}
                  color="#475467"
                  fontSize="12px"
                  textDecoration="underline"
                  cursor="pointer"
                >
                  View
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default Announcements;
